import React from "react";
import SubLevels from "./SubLevels";

const Section = ({ section, openSubSection, handleSubClick, resourcesLink }) => {
    const { title, sublevels } = section;

    let sectionOpen = "sectionTabClosed";
    let subSectionClass = "hideMobileContent";
    let arrowClass = "arrow arrow--active";

    if (openSubSection === title) {
        subSectionClass = "showMobileContent";
        sectionOpen = "sectionTabOpen";
        arrowClass = "arrow";
    }

    return (
        <React.Fragment key={title}>
            <div
                onClick={(e) => handleSubClick(e, title)}
                onKeyDown={(e) => handleSubClick(e, title)}
                key={title}
                className={sectionOpen}
            >
                <button type="button" className="sectionLabel">
                    {title}
                </button>
                <div className={arrowClass} />
            </div>
            <div className={subSectionClass} role="button">
                {sublevels && <SubLevels resourcesLink={resourcesLink} sublevels={sublevels} />}
            </div>
        </React.Fragment>
    );
};

export default Section;
